/**
 * Created by Adam on 11/3/2017.
 */

exports.init = function($) {




        $(window).scroll(function() {
            if($('#alert-notification').length){
                var alertMessageHeight = $('#alert-notification').outerHeight() + 100;
                if ($(document).scrollTop() > alertMessageHeight) {
                    $('#masthead').addClass('transition');
                }
                else {
                    $('#masthead').removeClass('transition');
                }
            } else{
                if ($(document).scrollTop() > 100) {
                    $('#masthead').addClass('transition');
                }
                else {
                    $('#masthead').removeClass('transition');
                }
            }
        });

        $(document).click(function(e) {
            $('body').removeClass('menu-open-windows-only');//fgcuteam
            $('body').removeClass('menu-open');

            $('#nav-main').attr('aria-hidden', 'true');
            $('#main-menu-toggle').attr('aria-expanded', 'false');
        });

        var searchParams = window.location.search;
        var lastScrollTop = 0;

        // $(window).scroll(function() {
        //     var header = $('#masthead');
        //     var headerHeight = header.outerHeight();
        //     var currentScrollTop = $(this).scrollTop();
        //     var alertMsg = $('#alert-notification');
        //
        //     //sets the height for the header to scroll into place when alert present
        //     if ($(alertMsg).length) {
        //         var alertHeight = $(alertMsg).outerHeight();
        //     } else {
        //         var alertHeight = 0;
        //     }
        //
        //     if (currentScrollTop === 0 || currentScrollTop < alertHeight) {
        //         header.removeClass('fix-header');
        //     } else {
        //         if (currentScrollTop > lastScrollTop) {
        //             // scroll down
        //             header.removeClass('fix-header');
        //
        //         } else {
        //             // scroll up
        //             header.addClass('fix-header');
        //         }
        //     }
        //
        //     if ($('.page-navigation-wrapper').length) {
        //         var pageNavHeight = $('.page-navigation').outerHeight();
        //         var pageNavWrapper = $('.page-navigation-wrapper').offset().top;
        //         if (currentScrollTop > pageNavWrapper - pageNavHeight ) {
        //             if (header.hasClass('fix-header')) {
        //                 $('.page-navigation').css({position: 'fixed', top: headerHeight, bottom: 'auto', transition: 'all 0.3s'});
        //             } else {
        //                 $('.page-navigation').css({position: 'fixed', top: '0', bottom: 'auto', transition: 'all 0.3s'});
        //             }
        //             $('.page-navigation').addClass('sticky-nav');
        //         } else {
        //             $('.page-navigation').removeAttr('style');
        //             $('.page-navigation').removeClass('sticky-nav');
        //         }
        //     }
        //
        //     lastScrollTop = currentScrollTop;
        // });



        //inThisSection nav logic
        $.fn.sortByDepth = function() {
            var ar = this.map(function() {
                    return {length: $(this).parents().length, elt: this}
                }).get(),
                result = [],
                i = ar.length;


            ar.sort(function(a, b) {
                return a.length - b.length;
            });

            while (i--) {
                result.push(ar[i].elt);
            }
            return $(result);
        };

        //college landing func
        $('.mentorship').click( function() {

            if ($(this).closest('.story-bubble-wrapper').hasClass('engagement')) {
                $(this).closest('.story-bubble-wrapper').removeClass('engagement');
                $(this).closest('.story-bubble-wrapper').addClass('mentorship');
            } else if ($(this).closest('.story-bubble-wrapper').hasClass('mentorship')) {
                $(this).closest('.story-bubble-wrapper').removeClass('mentorship');
                $(this).closest('.story-bubble-wrapper').removeClass('active-state');
            } else {
                $(this).closest('.story-bubble-wrapper').addClass('mentorship');
                $(this).closest('.story-bubble-wrapper').addClass('active-state');

            }
        });

        $('.engagement').click( function() {
            if ($(this).closest('.story-bubble-wrapper').hasClass('mentorship')) {
                $(this).closest('.story-bubble-wrapper').removeClass('mentorship');
                $(this).closest('.story-bubble-wrapper').addClass('engagement');
            } else if ($(this).closest('.story-bubble-wrapper').hasClass('engagement')) {
                $(this).closest('.story-bubble-wrapper').removeClass('engagement');
                $(this).closest('.story-bubble-wrapper').removeClass('active-state');
            } else {
                $(this).closest('.story-bubble-wrapper').addClass('engagement');
                $(this).closest('.story-bubble-wrapper').addClass('active-state');
            }
        });

        // Page Load
        var allSectionUls = $('#nav-inner ul').sortByDepth().each( function(){
            var childMenu = $(this).children('li.has-children').remove();
            $(this).append(childMenu);
        });

        // Set active menu item siblings to display
        $('#nav-inner .active').addClass('expanded').siblings('li').show();
        $('#nav-inner .active').parent('ul').parent('li').removeClass('expanded');

        // On click of parent menus (not the active page)
        $('li.has-children:not(.active) > button.toggle-menu','#nav-inner').on('click', function(e){
            var thisEL = $(this).parent('li.has-children:not(.active)');
            // if expanded do...
            if($(thisEL).hasClass('expanded')) {
                $("#nav-inner li:not(.has-children):visible").slideUp();
                $(".has-children").addClass("expanded");
                $(thisEL).removeClass('expanded');
                $(thisEL).find('> ul > li:not(.has-children)').slideDown();
                // If not expanded do...
            } else {
                $(thisEL).addClass('expanded');
                $(thisEL).children('ul').show();
                $(thisEL).find('> ul > li:not(.has-children)').slideUp();
            }
        });

        // On click of the current page list item (Change to button)
        $('li.has-children.active > button.toggle-menu','#nav-inner').on('click', function(e){
            var thisEL = $(this).parent('li.has-children.active');
            // if expanded do...
            if($(thisEL).hasClass('expanded')) {
                $("#nav-inner li:not(.has-children):visible").slideUp();
                $(".has-children").addClass("expanded");
                $(thisEL).removeClass('expanded');
                $(thisEL).find('> ul > li:not(.has-children)').slideDown();
                // If not expanded do...
            } else {
                $(thisEL).addClass('expanded');
                $(thisEL).children('ul').show();
                $(thisEL).find('> ul > li:not(.has-children)').slideUp();
            }
        });

        $('.close-alert').click( function() {
            $('#alert-notification').slideUp();
        });


        if($('.hero-video iframe').length){
            $('.hero-video').addClass('youtube');
        }

        var player;
        $('.play-button').click( function(event) {
            event.preventDefault();
            var src = "";
            var querySep = "";
            var iframe = $(this).siblings('iframe');

            if ($(this).parents().hasClass('hero')) {
                $(this).closest('.video-overlay-container').fadeOut();

                if(!$('.hero-video').hasClass('youtube')){
                    $('#hero-video')[0].play();
                } else{
                    videoUrl = $('.hero-video').attr("data-video-src");
                    $('.hero-video.youtube iframe').attr("src", videoUrl);
                }

            } else {

                //checks if in .see-for-yourself section
                if ($(this).closest('section').hasClass('see-for-yourself') && Modernizr.mq('(min-width: 1000px)')) {
                    $(this).closest('section.see-for-yourself').addClass('theater-mode');
                    var theater = true;
                } else {
                    var theater = false;
                }

                if(Modernizr.mq('(min-width: 1000px)')) {
                    src = iframe.attr("src");
                    querySep = (src.indexOf('?') > 0) ? "&" : "?";

                    if(src.indexOf('youtube.com') > 0) {

                        player = new YT.Player(iframe.attr('id'), {
                            events : {
                                'onStateChange' : onStateChange
                            }
                        });

                        $(document).one('click', function stopVideo (e){
                            if($('iframe').has(e.target).length === 0){
                                $('section.see-for-yourself').removeClass('theater-mode');
                                player.stopVideo();
                                iframe.hide();
                            } else {
                                $(document).one('click', stopVideo);
                            }
                        });

                        function onStateChange() {
                            console.log(player);
                            if(player.getPlayerState() == 0) {
                                iframe.hide();
                                if (theater == true) {
                                    $('section.see-for-yourself').removeClass('theater-mode');
                                }
                            }
                        }
                    }

                    if(src.indexOf("autoplay") < 0)
                        src = src + querySep + "autoplay=1";

                    iframe.attr("src", src);

                    if(src.indexOf('youtube.com') > 0 && src.indexOf("enablejsapi") < 0)
                        iframe.attr("src", src + "&enablejsapi=1");

                    iframe.show();

                } else {
                    src = $(this).attr('href');
                    querySep = (src.indexOf('?') > 0) ? "&" : "?";

                    src.replace(new RegExp("watch\\?v=", "i"), 'v/');

                    if(src.indexOf("autoplay") < 0)
                        src += querySep + "autoplay=1";

                    if(src.indexOf('youtube.com') > 0 && src.indexOf("enablejsapi") < 0){
                        src += "&enablejsapi=1";
                    }

                    var instance = $.fancybox.open({
                        src  : src,
                        type : 'iframe',
                        opts : {
                        }
                    });

                    iframe = $(instance.slides[0].$content[0]).find("iframe");

                    if(src.indexOf('youtube.com') > 0) {
                        player = new YT.Player(iframe.attr('id'), {
                            events : {
                                'onStateChange' : onStateChange
                            }
                        });

                        function onStateChange() {
                            if(player.getPlayerState() == 0) {
                                instance.close();
                            }
                        }
                    }
                }
            }

            return false;
        });

        var $div = $('.dropdown-menu.inner');
        $div.on('mousewheel DOMMouseScroll', function(e) {
            var d = e.originalEvent.wheelDelta || -e.originalEvent.detail,
                sh = this.scrollHeight,
                oh = this.offsetHeight,
                st = this.scrollTop;
            dir = d > 0 ? 'up' : 'down';
            if(dir == 'up' && (d > st ||  st == 0)){
                $(this).scrollTop(0);
                e.stopPropagation();
                e.preventDefault();
                e.returnValue = false;
            } else if(dir == 'down' && (-d > sh - oh - st || st == sh - oh)){
                $(this).scrollTop(sh);
                e.stopPropagation();
                e.preventDefault();
                e.returnValue = false;
            }
        });



        var activeClasses = 'pathway-active environment-active restore-active';
        $('.icons .icon').click( function() {
            $(this).closest('.the-fgu-effect').removeClass(activeClasses);
            if  ($(this).attr('id') == 'pathway') {
                $(this).closest('.the-fgu-effect').addClass('pathway-active');
            }
            if  ($(this).attr('id') == 'environment') {
                $(this).closest('.the-fgu-effect').addClass('environment-active');
            }
            if  ($(this).attr('id') == 'restore') {
                $(this).closest('.the-fgu-effect').addClass('restore-active');
            }
            $(this).closest('.the-fgu-effect').addClass('active');
            $('#reset-the-fgcu-effect').show();
        });

        //reset The FGCU Effect section
        $('#reset-the-fgcu-effect').click( function() {
            $(this).closest('.the-fgu-effect').removeClass(activeClasses).removeClass('active');
            $(this).hide();
        });

        //var navPanelHeight = $('#nav-main .left-panel').outerHeight();
        $('#nav-main').wrap('<div class="nav-wrapper"></div>');
        //Toggle Main Menu
        $('#main-menu-toggle').click( function(e) {
            e.preventDefault();
            e.stopPropagation();
            //aria toggling
            if ($(this).attr('aria-expanded') === 'true') {
                $(this).attr('aria-expanded', 'false');
                if (navigator.appVersion.indexOf("Win")!=-1)  $('.fab-wrapper').css('right', '25px');//fgcuteam for fab-wrapper preventing moving on scrolbar hiding.

            } else {
                $(this).attr('aria-expanded', 'true');
                if (navigator.appVersion.indexOf("Win")!=-1) $('.fab-wrapper').css('right', '42px');//fgcuteam for fab-wrapper preventing moving on scrolbar hiding.
            }

            if ($(this).siblings('#nav-main').attr('aria-hidden') === 'true') {
                $(this).siblings('#nav-main').attr('aria-hidden', 'false');
            } else {
                $(this).siblings('#nav-main').attr('aria-hidden', 'true');
            }

            //toggling menu
            $('body').toggleClass('menu-open');
            $('#anv-main').slideToggle(300);
            var alertHeight = $('#alert-notification').outerHeight();
            var headerHeight = $('#masthead').outerHeight();
            var navMainHeight = $('#nav-main').outerHeight();
            var windowHeight = $(window).height();
            var combinedHeights = alertHeight + headerHeight + navMainHeight;
            var newNavHeight = windowHeight - alertHeight - headerHeight;

            if (navigator.appVersion.indexOf("Win")!=-1) //fgcuteam
            {
                $('body').toggleClass('menu-open-windows-only');
            }

            if (($(".nav-wrapper").offset().top + $(".nav-wrapper").height()) >= $(window).height()) {
                $('.nav-wrapper').css('height', newNavHeight);
                $('.nav-wrapper').css('min-height', '0');
                $('.nav-wrapper').css('overflow-y', 'auto');
            }

        });

        $('#nav-main').click( function(e) {
            e.preventDefault();
            e.stopPropagation();
        });

        //Toggle Main Menu Items
        $('#nav-main button').click( function() {
            var thisEl = $(this);
            //reset accessibility
            $('#nav-main .expanded button').attr('aria-expanded', 'false');
            $('#nav-main .expanded').children('ul.sub-menu').attr('aria-hidden', 'true');

            //collapse open menus
            $('#nav-main .expanded').not($(this).parent()).children('ul').slideToggle(300);
            $('#nav-main li, #nav-main div').not($(this).parent()).removeClass('expanded');

            //toggling click menu
            $(this).parent().toggleClass('expanded');
            $(this).siblings('ul.sub-menu').slideToggle(300);

            //aria toggling
            if (!$(this).parent().hasClass('expanded')) {
                $(this).attr('aria-expanded', 'false');
                $(this).siblings('ul').attr('aria-hidden', 'true');
            } else {
                $(this).attr('aria-expanded', 'true');
                $(this).siblings('ul').attr('aria-hidden', 'false');
            }

            var alertHeight = $('#alert-notification').outerHeight();
            var headerHeight = $('#masthead').outerHeight();
            var navMainHeight = $('#nav-main').outerHeight();
            var windowHeight = $(window).height();
            var combinedHeights = alertHeight + headerHeight + navMainHeight;
            var newNavHeight = windowHeight - alertHeight - headerHeight;
            if (($(".nav-wrapper").offset().top + $(".nav-wrapper").outerHeight()) >= $(window).height()) {
                $('.nav-wrapper').css('height', newNavHeight);
                $('.nav-wrapper').css('min-height', '0');
                $('.nav-wrapper').css('overflow-y', 'auto');
            }

        });

        //accordian accessibility
        $('.accordion-controls button.open').click( function() {

            $('.accordion-wrapper > ul > li').addClass('expanded').find('.toggle-accordion').attr('aria-expanded', 'true');
            $('.accordion-wrapper > ul > li .more-info').slideDown().attr('aria-hidden', 'false');
            $('.accordion-controls').addClass('all-expanded').removeClass('all-collapsed');
        });

        $('.accordion-controls button.close').click( function() {

            $('.accordion-wrapper > ul > li').removeClass('expanded').find('.toggle-accordion').attr('aria-expanded', 'false');
            $('.accordion-wrapper > ul > li .more-info').slideUp().attr('aria-hidden', 'true');
            $('.accordion-controls').removeClass('all-expanded').addClass('all-collapsed');

        });

        //section nav
        $('.toggle-section-nav').click( function() {
            $('#nav-inner').slideToggle(300);
            if ($(this).attr('aria-expanded') === 'true') {
                $(this).removeClass('expanded');
                $(this).attr('aria-expanded', 'false');
                $(this).siblings('#nav-inner').attr('aria-hidden', 'true');
            } else {
                $(this).addClass('expanded');
                $(this).attr('aria-expanded', 'true');
                $(this).siblings('#nav-inner').attr('aria-hidden', 'false');
            }
        });

        $('.toggle-accordion').each(function() {
            $(this).click( function() {
                if ($(this).attr('aria-expanded') === 'true') {
                    $(this).attr('aria-expanded', 'false');
                    $(this).siblings('.more-info').attr('aria-hidden', 'true');
                    $(this).closest('li').removeClass('expanded');
                    $(this).siblings('div.more-info').slideUp();
                } else {
                    $(this).attr('aria-expanded', 'true');
                    $(this).siblings('.more-info').attr('aria-hidden', 'false');
                    $(this).closest('li').addClass('expanded');
                    $(this).siblings('div.more-info').slideDown();
                    $(this).parent().siblings().find('div.more-info').slideUp().attr('aria-hidden', 'true');
                    $(this).parent().siblings().find('.toggle-accordion').attr('aria-expanded', 'false');
                    $(this).parent().siblings().removeClass('expanded');
                }

            });
        });


        $('button.toggle-accordion-list').click( function() {
            $('.accordion-wrapper li.expanded button.toggle-accordion-list').not(this).click();
            if ($(this).attr('aria-expanded') === 'true') {
                $(this).attr('aria-expanded', 'false');
                $(this).siblings('.more-info').attr('aria-hidden', 'true');
                $(this).closest('li').removeClass('expanded');
                $(this).siblings('div.more-info').slideUp();
            } else {
                $(this).attr('aria-expanded', 'true');
                $(this).siblings('.more-info').attr('aria-hidden', 'false');
                $(this).closest('li').addClass('expanded');
                $(this).siblings('div.more-info').slideDown();
            }
        });

        //accordian scroll to top
        $('button.accordion-top').click( function() {
            var thisEl = $(this).closest('.accordion-wrapper').offset().top;
            var pageNav = $('.page-navigation');
            //checks if pageNav is present and adjust scroll top to compensate
            var pageNavHeight = (pageNav.length !== '0') ? pageNav.outerHeight() :'0';
            $('body,html').animate({scrollTop: thisEl - $('#masthead').outerHeight() - $('.page-navigation').outerHeight() - 20},'slow');
            $(this).closest('.accordion-wrapper').find('.accordion-controls button.open').focus();
        });

        //generic toggle accessibility
        $('button.toggle-dropdown').click( function() {
            if ($(this).attr('aria-expanded') === 'true') {
                $(this).attr('aria-expanded', 'false');
                $(this).siblings('.dropdown').attr('aria-hidden', 'true').slideUp();
                $(this).removeClass('expanded');
            } else {
                $(this).attr('aria-expanded', 'true');
                $(this).siblings('.dropdown').attr('aria-hidden', 'false').slideDown();
                $(this).addClass('expanded');
            }
        });

        //accessibility tab loops
        $('#main-menu-toggle').on('keydown', function(e){
            if ((e.keyCode || e.which && !e.shiftKey) == 9) {
                if ($('body').hasClass('menu-open')) {
                    $('.main-menu > li:first-child > a').focus();
                    e.preventDefault();
                }
            }
            if(e.shiftKey && e.keyCode == 9){
                $('.social-menu a:last-child').focus();
            }
        });

        $('.social-menu ul > li:last-child a').on('keydown', function(e) {
            if ((e.keyCode || e.which) == 9) {
                if (!e.shiftKey && $('body').hasClass('menu-open')) {
                    $('#main-menu-toggle').focus();
                    e.preventDefault();
                }
            }
        });

        //show and hide search
        $('#main-search-toggle').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('body').toggleClass('search-open');

            if ($('body').hasClass('menu-open')) {
                $('#main-menu-toggle').click();
            }

            $('.search-form-container').toggleClass('expanded');

            $(document).one('click', function closeMenu (e){
                if($('.search-form-container').has(e.target).length === 0){
                    $('.search-form-container').removeClass('expanded');
                    $('body').removeClass('search-open');
                } else {
                    $(document).one('click', closeMenu);
                }
            });

            if ($('body').hasClass('search-open')) {
                $('#site-search').focus();
            }
        });

        //reset aria labeling on desktop for elements that are no longer collapsed menus
        var resizeId;
        $(window).on('load resize', function() {
            clearTimeout(resizeId);
            resizeId = setTimeout(doneResizing, 500);

        });

        function doneResizing(){
            var windowWidth = $(window).width();
            if (windowWidth > 768) {
                $('.related-subjects button.toggle-dropdown').attr('aria-expanded', 'true');
                $('.related-subjects .dropdown').attr('aria-hidden', 'false');
            } else {
                $('')
                $('.related-subjects button.toggle-dropdown').attr('aria-expanded', 'false');
                $('.related-subjects .dropdown').attr('aria-hidden', 'true');

                //reset dropdown state
                $('.related-subjects .dropdown').slideUp();
                $('.related-subjects button.toggle-dropdown').removeClass('expanded');
            }
            if (windowWidth > 1000) {
                $('#nav-main .right-panel button').attr('aria-expanded', 'true');
                $('#nav-main .right-panel ul.sub-menu').attr('aria-hidden', 'false');
            } else {
                $('#nav-main .right-panel button').attr('aria-expanded', 'false');
                $('#nav-main .expanded').removeClass('expanded');
                $('#nav-main .right-panel ul.sub-menu').attr('aria-hidden', 'true');
                $('#nav-main ul.sub-menu').slideUp();
            }
        }

        /*
         ###################################################################################################
         ##wraps last word into <span class="last-word"> - this is used so that the arrow icon does not wrap before the last word
         ###################################################################################################
         */
        $('.news-events-listing-main .row .col-lg-16 a, .event-grid .event .title, .event-wrapper a.title, .press-release-list a, .news-list a.title').html(function(){
            // separate the text by spaces
            var text= $(this).text().split(' ');
            // drop the last word and store it in a variable
            var last = text.pop();
            // join the text back and if it has more than 1 word add the span tag
            // to the last word
            return text.join(" ") + (text.length >= 0 ? ' <span class="last-word">'+last+'</span>' : last);
        });

        $(window).trigger('resize').trigger('scroll');



        /*
         ###################################################################################################
         ##adds overflow scroll to section nav when the section nav is taller than the window
         ###################################################################################################
         */
        // $(window).on("load resize",function(e){
        //     if($('.page-navigation').hasClass('sticky-nav')){
        //         var windowHeight = $(window).height() - 55;
        //         if ($(window).height() <= windowHeight + 55) {
        //             $('#nav-inner').css('max-height', windowHeight);
        //         }
        //     } else if(!$('.page-navigation').hasClass('sticky-nav')){
        //         var windowHeight = $(window).height() - 155;
        //         if ($(window).height() <= windowHeight + 155) {
        //             $('#nav-inner').css('max-height', windowHeight);
        //         }
        //     }
        // });


        //fab wrapper
        $('.touch .fab-wrapper').click( function(e) {
            $(this).toggleClass('clicked');
            e.stopPropagation();
        });

        $(window).click( function(e) {
            $('.touch .fab-wrapper').removeClass('clicked');
        });

        //parallax fix after using accordion
        $('.more-content-button').click( function() {
            setTimeout(function(){ $(window).trigger('resize.px.parallax'); }, 400);
        });

        $('.paginate_button').click( function() {
            setTimeout(function(){ $(window).trigger('resize.px.parallax'); }, 200);
        });

        if ($('.mashup-content').length){
            setTimeout(function(){ $(window).trigger('resize.px.parallax'); }, 200);
        }

        var $el = $('.page-banner > .desktop-banner[style*="background-image"]');
        var $el2 = $('.page-banner > .desktop-banner .tablet-banner[style*="background-image"]');
        var $el3 = $('.page-banner > .desktop-banner .mobile-banner[style*="background-image"]');
        if ($el){
            $('.page-banner > .desktop-banner').addClass('no-bg');
        }
        if ($el2){
            $('.page-banner > .desktop-banner .tablet-banner').addClass('no-bg');
        }
        if ($el3){
            $('.page-banner > .desktop-banner .mobile-banner').addClass('no-bg');
        }





};